import bridge from "@vkontakte/vk-bridge";

function shareLink(params) {
  bridge.send('VKWebAppShare', {'link': `https://vk.com/app7427506#${params}`}).catch(()=>{})
}

export default shareLink